import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed, watch } from 'vue';
import { useAutoResetState } from '@/composable/useAutoResetState';
import { getSelectionPointForTicket, hasBetBuilderLiveScore } from '@/core/lib/betBuilderHelper';
import { defineContext } from '@/core/lib/defineContext';
import { formatLiveScore } from '@/core/oddsApi/helpers/liveScore';
import type { IBetBuilderTicket } from '@/interface/betBuilder';
import { useBetSlipStore } from '@/store/betSlipStore';

export const BetBuilderTicketContext = defineContext('BetBuilderTicketContext', (ticket: Ref<IBetBuilderTicket>) => {
    const pointDisplay = computed(() => getSelectionPointForTicket(ticket.value));
    const [isPointChange, setPointChange] = useAutoResetState(false, 3000);
    watch(pointDisplay, () => setPointChange(true));

    const { betBuilderBetSlip } = storeToRefs(useBetSlipStore());

    const selectionLiveScore = computed(() => betBuilderBetSlip.value?.selectionLiveScores.get(ticket.value.selection.id) ?? null);

    const liveScoreDisplay = computed(() => {
        const { match, market } = ticket.value;

        if (!hasBetBuilderLiveScore(match, market.marketType.id)) {
            return null;
        }

        return selectionLiveScore.value
            ? formatLiveScore(selectionLiveScore.value.home, selectionLiveScore.value.away, ':')
            : null;
    });
    const [isScoreChange, setScoreChange] = useAutoResetState(false, 3000);
    watch(liveScoreDisplay, (newScore, oldScore) => {
        if (oldScore === null || newScore === null) {
            return;
        }
        setScoreChange(true);
    });

    return {
        pointDisplay,
        isPointChange,
        liveScoreDisplay,
        isScoreChange,
    };
});
